import interpolateComponents from '@automattic/interpolate-components';
import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box/Box';
import { LegacyButton } from 'components/LegacyButton/LegacyButton';
import type { SalariesJobTitle } from 'modules/salaries/types/SalariesJobTitle';
import { colors, fontWeights } from 'theme/theme';

import { Card } from './Card';
import { Container } from './Container';
import { BigButton, StyledLinkButton } from './JobSelector.styled';

type Props = {
  suggestion?: { name: string; jobTitle: SalariesJobTitle; objectID: string };
  onSelect: (arg0: {
    name: string;
    familyId: string;
    id: string;
    synonymId: string;
  }) => void;
  title: string;
  onContinue?: () => void;
};

export function NoJobsMatch({
  suggestion,
  onSelect,
  title,
  onContinue,
}: Props) {
  return (
    <Container>
      <Card
        content={{
          name: (
            <>
              {getText('We don’t currently have a match for this job title')}
              &hellip;
            </>
          ),
          body:
            suggestion &&
            interpolateComponents({
              mixedString:
                /* TRANSLATORS: salary survey, continue with free text job title */
                sprintf(getText('Did you mean {{link}}%(title)s{{/link}}?'), {
                  title: suggestion.name,
                }),
              components: {
                link: (
                  <StyledLinkButton
                    data-qa-id="suggestion-link"
                    onClick={() =>
                      onSelect({
                        name: suggestion.name,
                        id: suggestion.jobTitle.id,
                        familyId: suggestion.jobTitle.familyId,
                        synonymId: suggestion.objectID,
                      })
                    }
                  />
                ),
              },
            }),
          description: suggestion
            ? undefined
            : getText('Try searching for a related or more general title'),
        }}
      />
      {onContinue && (
        <BigButton
          component={LegacyButton}
          data-qa-id="continue-link"
          onClick={onContinue}
        >
          <Box py={[12, null, 24]} px={[24, null, 44]}>
            {interpolateComponents({
              mixedString:
                /* TRANSLATORS: salary survey, continue with free text job title */
                sprintf(getText('Continue with {{link}}%(title)s{{/link}}'), {
                  title,
                }),
              components: {
                link: (
                  <Box
                    component="span"
                    fontWeight={fontWeights.semiBold}
                    color={colors.brandBlue}
                  />
                ),
              },
            })}
          </Box>
        </BigButton>
      )}
    </Container>
  );
}
